export enum RolesType {
  Lærer = "Lærer",
  Student = "Student",
}
